import React, { Component } from 'react';
import styled from 'styled-components';
import LineDivider from '../../FeatureComponents/LineDivider';
import Footer from '../../FeatureComponents/Footer/index';
import OverlayFeedback from '../../FeatureComponents/OverlayFeedback';

const StyledClearSessionOverlay = styled.div`
    & .sf-confirm{
        background :#2c387a
    }
`
// #2c387a
//${props => props.data.primaryColor}

interface IProps{
    handleModalToggle,
    data,
    logoutUser,
    selectedStar,
    website?,
    isFeedbackEnable
}


class ClearSessionOverlay extends Component<IProps,{}> {
    state={
        isOverlayFeedbackVisible : false,
        selectedRating: "",
        closeFlag: true, 
    }
    toggleOverlayFeedback(selectedRating){ 
        this.setState({
            isOverlayFeedbackVisible: !this.state.isOverlayFeedbackVisible,
            selectedRating: selectedRating
        })
    }
    
    componentDidMount(){
        this.setState({selectedRating:this.props.selectedStar});
    }
    render() {
        return (
            
            <StyledClearSessionOverlay {...this.props}>
                {this.state.isOverlayFeedbackVisible ?  
                <OverlayFeedback
                     toggleOverlayFeedback={this.toggleOverlayFeedback.bind(this)}
                     // selectedRating={"3"}
                     selectedRating={this.state.selectedRating}
                     isLoginUser={this.props.logoutUser}
                     handleModalToggle={this.props.handleModalToggle}
                     closeFlag={this.state.closeFlag}
                     website={this.props.website}
                />
               :null }
            <div className="sf-chatmodal-overlay">
                <div style={{height:this.state.closeFlag ?"280px":"none"}} className="sf-chatmodal-body">
                    <div className="sf-chatmodal-content">
                        <p style={{margin: "0 0 16px"}}>
                            On exiting, all chat history will be cleared.
                        </p>
                        <button className="sf-chatmodal-btn sf-confirm"
                             onClick={this.props.handleModalToggle.bind(this,true)}>
                            Confirm
                        </button>
                        <button className="sf-chatmodal-btn sf-cancel"
                                style={{marginTop: "10px"}}
                                onClick={this.props.handleModalToggle.bind(this,false)}
                            >
                            Cancel
                        </button>
                    </div>
                    <LineDivider></LineDivider>
                    <Footer data={this.props.data}
                        isOverlayVisible={this.state.isOverlayFeedbackVisible}
                        showOverlayFeedback={this.toggleOverlayFeedback.bind(this)}
                        selectedRating={this.state.selectedRating}
                        closeFlag={this.state.closeFlag}
                        isFeedbackEnable={this.props.isFeedbackEnable}
                    /> 
                </div>
            </div>
            </StyledClearSessionOverlay>
        );
    }
}

export default ClearSessionOverlay;